import { render, staticRenderFns } from "./PositionGuid.vue?vue&type=template&id=7a032d3b&"
import script from "./PositionGuid.vue?vue&type=script&lang=js&"
export * from "./PositionGuid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports